<template>
  <div v-if="isLoaded" class="page-grid">
    <StatusBar :farm="farm"></StatusBar>
    <div class="selected-staff">
      <EmployeeCard v-if="farm.employeeById(selectedEmployeeId) !== undefined"
                    :employee="farm.employeeById(selectedEmployeeId)"
                    :farm="farm"
                    ondragstart="return false"
      />
      <div v-else-if="farm.state.employees.length < 1" class="no-selected">
        <h1>Hire an employee in the Office</h1>
      </div>
      <div v-else class="no-selected">
        <h1>Select an employee</h1>
      </div>
    </div>
    <div class="staff-list">
      <template v-for="employee in farm.state.employees" v-bind:key="employee">
        <EmployeeCardSmall :image="employee.image"
                           :title="employee.name"
                           :employee="employee"
                           @click="select(employee)"
                           :class="{'selected-employee': selectedEmployeeId === employee.uuid}"
                           ondragstart="return false"
        />
      </template>
  </div>
    <!--<div v-if="farm.state.employees.length < farm.state.staffLimit.max"
         class="farm-window hire-new" @click="hireNew()" title="Hire another employee"
         :class="{'disabled-window': !farm.canHire}">
      <div class="plus-horizontal"></div>
      <div class="plus-vertical"></div>
      <div class="hire-new-text">
        <div class="hiringCost"><p>${{ farm.hiringCost() }}</p></div>
        <div class="hiringLimit"><p>{{ farm.employeeLimitString }}</p></div>
      </div>
    </div>-->
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import Farm from '@/farm/Farm'
import EmployeeCard from '@/components/EmployeeCard.vue'
import ValueMeter from '@/components/ui/ValueMeter.vue'
import EmployeeCardSmall from '@/components/EmployeeCardSmall.vue'
import Research from '@/Research'
import Employee from '@/employee/Employee'
import FarmStatusCard from '@/components/FarmStatusCard.vue'
import StatusBar from '@/components/StatusBar.vue'

@Options({
  components: {
    EmployeeCard, EmployeeCardSmall, ValueMeter, FarmStatusCard, StatusBar
  },
  props: {
    farm: Object
  },
  emits: ['close'],
  methods: {
    log(msg: any) {
      console.log(msg)
    },
    select(e: Employee) {
      this.selectedEmployeeId = e.uuid
    },
    hireNew() {
      this.farm.hire()
      if (this.farm.state.employees.length > 0) {
        this.select(this.farm.state.employees[this.farm.state.employees.length - 1])
      }
    }
  },
  computed: {
  },
  async created() {
    //let farm = new Farm()
    //await farm.load()
    //this.farm = farm
    this.isLoaded = true
  }
})
export default class PastureView extends Vue {
  isLoaded = false
  farm!: Farm
  selectedEmployeeId = ''
}
</script>

<style lang="scss">

</style>

<style scoped lang="scss">
  .page-grid {
    height: auto;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto auto;
    grid-template-areas:
      "s s"
      "e e"
      "l l";

    @media screen and (max-width: $mobile-width){
      grid-template-columns: 1fr;
      grid-template-rows: auto auto auto;
      grid-template-areas:
        "s"
        "e"
        "l";
    }
  }

  .status-bar {
    grid-area: s;
  }

  .selected-staff {
    grid-area: e;

    box-sizing: border-box;
    width: 100%;
    max-width: $main-column-max-width;
    margin: auto;
  }

  .staff-list {
    grid-area: l;

    display: grid;
    grid-auto-columns: 130px;
    grid-template-rows: 200px;
    grid-gap: 10px;
    grid-auto-flow: column;
    //overflow-x: hidden;
    overflow-y: hidden;
    width: min-content; // Make this component only as wide as it needs to be
    max-width: 100%; // Limit this components max width so that we get overflow-x if it has too much content.
    margin-left: auto; // Center component
    margin-right: auto; // Center component
    margin-bottom: 10px;

    @media screen and (max-width: $mobile-width){
      grid-auto-columns: 120px;
      grid-template-rows: 180px;
    }
  }

  .hire-new {
    //border: 1px solid black;
    cursor: pointer;
    position: relative;
    background-color: $component-background-color;
    transition: border $selection-time;
    user-select: none;

    &:hover {
      border-color: $highlight-color;
      color: $highlight-color;

      & > .plus {
        background-color: $highlight-color;
      }
    }

    p {
      text-align: center;
    }

    div {
      transition: color $selection-time;
    }

    .plus {
      background-color: $component-base-color;
      position: absolute;
      transition: background-color $selection-time;
    }

    .plus-horizontal {
      @extend .plus;
      width: 150px;
      height: 40px;
      top: 125px;
      left: 25px;

      @media screen and (max-width: $mobile-width){
        width: 70px;
        height: 25px;
        top: 83px;
        left: 25px;
      }
    }

    .plus-vertical {
      @extend .plus;
      width: 40px;
      height: 150px;
      top: 70px;
      left: 80px;

      @media screen and (max-width: $mobile-width){
        width: 25px;
        height: 70px;
        top: 60px;
        left: 47px;
      }
    }

    .hire-new-text {
      height: 100%;
      display: grid;
      grid-template-rows: repeat(8, 1fr);

      p {
        margin-bottom: 0;
      }

      .hiringCost {
      }

      .hiringLimit {
        grid-row: 8;
      }
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: 50% 50%;
    }
  }

  .disabled-window > .plus-vertical, .disabled-window > .plus-horizontal {
    background-color: #777 !important;

  }

  .value-meter {
    height: 50px;
    background-color: #222;

    .milk-label {
      margin: 0;
      mix-blend-mode: exclusion;
      color: #fff;
      font-weight: bold;
    }
  }
</style>
